import { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GetRatingListAtom, SetRatingListAtom } from "../../store/ratingAtom";
import { customerService } from "../../services/customer.service";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";

function RatingSearch() {
  const RatingAtomData = GetRatingListAtom();
  const setRatingData = SetRatingListAtom();
  const [searchResult, setSearchResult] = useState([]);
  const [ratingList, setRatingList] = useState([]);
  const [textInput, setTextInput] = useState("");
  const navigate = useNavigate();
  const mountedRef = useRef(true);

  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];


  useEffect(() => {
    mountedRef.current = true;
    if (RatingAtomData.rating_info?.length > 0) {
      setRatingList(RatingAtomData.rating_info);
    } else {
      customerService.getRatingList().then((response) => {
        if (response?.data.rating_info) {
          setRatingData(response.data);
          setRatingList(response?.data?.rating_info);
        }
      });
    }

    return () => {
      mountedRef.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [RatingAtomData]);
  function itemSearchChange(search: string) {
    setTextInput(search);
  
    if (!search || search.trim().length < 2) {
      setSearchResult([]);
      return;
    }
  
    const lowerSearch = search.toLowerCase();
  
    const tempResult = RatingAtomData.rating_info?.filter((vendor: any) => {
      return (
        vendor?.Transaction_Type_Name?.toLowerCase().includes(lowerSearch) ||
        vendor?.Transaction_type_Id?.toString().includes(lowerSearch) ||
        vendor?.Rating_Value?.toString().includes(lowerSearch) ||
        vendor?.Total_Rating?.toString().includes(lowerSearch)
      );
    });
  
    setSearchResult(tempResult || []);
  }

  function selectedOption(vendor: any) {
    const { Transaction_type_Id } = vendor;
    setSearchResult([]);
    setTextInput("");
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${Transaction_type_Id}`
    );
  }

  return (
    <>
      <Combobox>
        <div className="relative max-w-sm w-full">
          <div className="relative">
            <Combobox.Input
              className=" w-full rounded-full border font-medium border-gray-300 bg-white py-1.5 pl-10 pr-4 text-sm text-gray-800 placeholder-gray-400 focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600"
              // displayValue={(person) => person.name}
              placeholder="Search in Rating"
              onChange={(event) => itemSearchChange(event.target.value)}
              // onChange={(event) => setTextInput(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-5 text-gray-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                />
              </svg>
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setTextInput("")}
          >
            <Combobox.Options className="absolute z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-sm shadow-lg ring-1 ring-black/10 focus:outline-none">
              {searchResult.length === 0 && textInput !== "" ? (
                <div className="relative cursor-default select-none px-4 py-2 text-gray-700">
                  Nothing found.
                </div>
              ) : (
                searchResult.map((rating: any, i: number) => (
                  <Combobox.Option
                    key={i}
                    onClick={() => selectedOption(rating)}
                    className={({ active }) =>
                      `relative cursor-pointer select-none text-xs font-medium py-2 pl-10 pr-4 ${
                        active ? "bg-gray-100 text-white" : "text-gray-700"
                      }`
                    }
                    value={rating}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={` ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {rating.Total_Rating} |{rating?.Transaction_Type_Name}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-gray-700"
                            }`}
                          >
                            <CheckIcon className="h-5 w-5" aria-hidden="true" />
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
    </>
  );
}

export default RatingSearch;
